import ED from '../NewImages/ED.webp'
import EAD from '../NewImages/AD.webp'
import PC from '../NewImages/PC.webp'
import MINI from '../NewImages/Mini.webp'
import ABD from '../NewImages/ABD.webp'
import MBA from '../NewImages/MBA.webp'
import projectManager from '../Images/pm.jpg'
import InformationManagement from '../Images/im.jpg'
import accounting from '../Images/accounting.webp'
import businessManagement from '../Images/bm.webp'
import CS from '../Images/cs.jpg'
import HumanResourceManagement from '../Images/Human_Resource_Management.webp'
import IT from '../Images/it.jpg'
import marketing from '../Images/marketing.webp'
import risKManagement from '../Images/risk_management.webp'
import salesManagement from '../Images/sm.jpg'
import SCM from '../Images/scm.jpg'
import SMM from '../Images/social_media_management.webp'
import FS from '../Images/fs.jpg'
import UI from '../Images/UI.webp'
import graphics from '../Images/graphics.webp'
import DA from '../Images/DA.jpg'
import IOT from '../Images/IOT.webp'
import blockchain from '../Images/blockchain.webp'
import SQL from '../Images/SQL.webp'
import devops from '../Images/devops.webp'
import network from '../Images/network.webp'
import cyber from '../Images/cyber.webp'
import excel from '../Images/excel.webp'
import powerBI from '../Images/power_BI.webp'
import dart from '../Images/dart.webp'
import html from '../Images/html.webp'
import pro from '../Images/pro.jpg'
import python from '../Images/python.webp'
import reactNative from '../Images/reactNative.webp'
import webDev from '../Images/webDev.webp'
import cloud from '../Images/cloud.webp'
import AI from '../Images/AI.webp'
import dataScience from '../Images/dataScience.webp'
import projectManagement from '../Images/projectManagement.webp'
import frontend from '../Images/Frontend.webp'
import bigData from '../Images/bigData.jpg'
import bm from '../Images/bm.jpg'
import laravel from '../Images/laravel.jpg'
import java from '../Images/java.jpg'
import payroll from '../Images/payroll.jpg'
import crm from '../Images/crm.jpg'
import bf from '../Images/bf.jpg'
import cb from '../Images/cb.jpg'
import pa from '../Images/pa.jpg'
import ta from '../Images/ta.jpg'
import hr from '../Images/hr.jpg'
import ph from '../Images/ph.jpg'
import pinterest from '../Images/pinterest.jpg'
import content from '../Images/content.jpg'
import aicm from '../Images/aicm.jpg'
import ccm from '../Images/ccm.jpg'
import Fintech from '../Images/Fintech.jpg'
import pam from '../Images/pam.jpg'
import om from '../Images/om.jpg'
import Hospitality from '../Images/Hospitality.jpg'
import oa from '../Images/oa.jpg'
import Procurement from '../Images/Procurement.jpg'
import Copywriting from '../Images/Copywriting.jpg'
import dm from '../Images/dm.jpg'
import me from '../Images/me.jpg'
import Inventory from '../Images/Inventory.jpg'
import Materials from '../Images/Materials.jpg'
import Logistics from '../Images/Logistics.jpg'
import Warehouse from '../Images/Warehouse.jpg'
import fm from '../Images/fm.jpg'
import HSE from '../Images/HSE.jpg'
import twitter from '../Images/twitter.jpg'
import facebook from '../Images/facebook.jpg'
import instagram from '../Images/instagram.jpg'
import productAnalysis from '../Images/productAnalysis.jpg'
import wordpress from '../Images/wordpress.jpg'
import pd from '../Images/pd.jpg'
import dt from '../Images/dt.webp'

const ProgramDetails = [
    {
        path: '/executive-advanced-diploma',
        programName: "EXECUTIVE ADVANCED DIPLOMA",
        programNamesOnCart: "Executive Advanced Diploma",
        programPrice: '20',
        heroImg: EAD,
        heroBigText: 'Get Certified in Just 4 Weeks   for Only $20',
        heroSmallText:
            'This fast, focused program delivers foundational business skills in just 4 weeks, making it perfect for aspiring professionals and early-career learners.',
        label: 'Explore Executive Advanced Diploma’s',
        programDetails: [
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/project-management',
                programImg: projectManager,
                programLabel: 'Project Management',
                programText:
                    'Master the principles of project management and gain globally recognized expertise to lead projects successfully.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 91,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A comprehensive program designed to teach you how to effectively plan, organize, and execute projects of any scale. From using globally recognized frameworks to mastering scheduling, budgeting, and resource allocation, this course equips you with the confidence and tools to lead cross-functional teams and deliver successful outcomes across industries.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/social-media-management',
                programImg: SMM,
                programLabel: 'Social Media Management',
                programText:
                    'Master content strategy, analytics, and growth techniques to manage and scale social media for modern brands.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 78,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'An intensive program that prepares you to design winning social media campaigns, analyze performance metrics, and grow digital communities. Learn how to create engaging content, manage brand reputation, and leverage advertising tools to drive measurable results for businesses and entrepreneurs in today’s competitive online space.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/customer-service',
                programImg: CS,
                programLabel: 'Customer Service',
                programText:
                    'Develop skills to manage customer relationships, resolve issues effectively, and deliver exceptional service experiences.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 86,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'This course is designed to help you deliver exceptional customer experiences by mastering communication, empathy, and conflict resolution. You will learn how to anticipate client needs, manage challenging situations, and build strong, lasting relationships that drive loyalty and satisfaction in any service-focused organization.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/accounting',
                programImg: accounting,
                programLabel: 'Accounting',
                programText:
                    'Gain practical accounting knowledge in financial reporting, budgeting, and business analysis for decision-making.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 93,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A practical program tailored to give you the foundations of accounting, including financial reporting, analysis, and budgeting. Learn how to interpret financial statements, apply accounting principles, and use financial data to make smarter business decisions that support growth and profitability in any organization.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/marketing',
                programImg: marketing,
                programLabel: 'Marketing',
                programText:
                    'Learn digital and strategic marketing to attract, engage, and convert customers across various platforms, both digital and traditional.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 88,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A results-driven course designed to give you both traditional and digital marketing expertise. From branding and consumer behavior to campaign strategy and analytics, this program equips you with practical tools to attract, engage, and convert audiences while driving measurable growth and revenue for businesses of any size.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/human-resource-management',
                programImg: HumanResourceManagement,
                programLabel: 'Human Resource Management',
                programText:
                    'Build core Human Resource (HR) skills in recruitment, employee development, and organizational performance.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 82,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A career-focused program that introduces you to the essential aspects of HR, including recruitment, employee training, performance management, and workplace culture. Gain insights into how HR strategies align with organizational goals and learn to create systems that foster productivity, engagement, and retention.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/supply-chain-management',
                programImg: SCM,
                programLabel: 'Supply Chain Management',
                programText:
                    'Understand logistics, procurement, and operations to successfully manage efficient, end-to-end supply chains globally.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 79,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'This program equips you with practical knowledge in procurement, logistics, and operations to optimize supply chains from start to finish. Learn how to balance costs, improve efficiency, and build resilient systems that meet global standards and keep businesses running smoothly in competitive markets.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/sales-management',
                programImg: salesManagement,
                programLabel: 'Sales Management',
                programText:
                    'Learn and master modern sales strategies, pipeline management, and negotiation to drive revenue and growth in any niche.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 89,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A high-impact program designed to sharpen your sales expertise, from prospecting and pipeline management to negotiation and closing techniques. Discover how to lead sales teams, analyze consumer behavior, and apply data-driven strategies to consistently exceed targets and drive sustainable business growth.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/risk-management',
                programImg: risKManagement,
                programLabel: 'Risk Management',
                programText:
                    'Learn to identify, assess, and manage business risks to protect and grow your organization. A core skill for any entrepreneur.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 76,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'This course teaches you how to identify, assess, and mitigate risks in financial, operational, and strategic areas of business. Through practical frameworks and case studies, you will gain the ability to protect organizations from uncertainty while creating strategies that strengthen long-term growth and stability.'
            },
            {
                addToCart: false,
                projectPath: '/executive-advanced-diploma/information-technology',
                programImg: IT,
                programLabel: 'Information Technology',
                programText:
                    'Understand IT systems, cybersecurity, and digital tools to support business operations and innovation in an every growing digital world.',
                programPrice: '20',
                programPriceInNG: '30,000',
                programName: "EXECUTIVE ADVANCED DIPLOMA",
                programNamesOnCart: "Executive Advanced Diploma",
                reviews: 95,
                duration: '1 Month',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Advanced Diploma Certificate upon completion',
                note: 'A future-focused program that helps you build essential IT knowledge, including systems management, cybersecurity, and digital innovation. Learn how to support business operations with technology, protect data from security threats, and apply digital tools that enable growth, efficiency, and transformation in any industry.'
            },
        ],
    },
    {
        path: '/associate-bachelor-degree',
        programName: 'ASSOCIATE BACHELOR DEGREE',
        heroImg: ABD,
        heroBigText: `Build a Strong Business Foundation   with an`,
        heroBigTextColored: `Associate Bachelor's Degree`,
        programPrice: "196",
        heroSmallText:
            'Get career-ready with flexible, self-paced Associate Bachelor’s programs in business, marketing, HR, and more. Fully online. Industry-relevant. Globally accessible.',
        label: `Explore Associate Bachelor's Degrees`,
        programDetails: [
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/social-media-management",
                programImg: SMM,
                programLabel: "Social Media Management",
                programText: "Explore the evolving world of social media and learn to manage digital platforms strategically and effectively.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 159,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program offers an in-depth exploration of social media platforms, digital storytelling, and online engagement strategies. Students will learn to analyze consumer behavior, design content that resonates with global audiences, and implement campaigns that drive measurable results. With a balance of academic theory and practical projects, graduates will be equipped to manage brands, foster online communities, and navigate the fast-paced digital landscape with confidence."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/customer-service",
                programImg: CS,
                programLabel: "Customer Service",
                programText: "Learn to master interpersonal communication and service delivery in today’s customer-centric business world.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 91,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program builds a strong academic and practical foundation in customer relationship management, service quality, and communication skills. Learners will study theories of consumer psychology while applying conflict resolution, negotiation, and client retention techniques in real-world scenarios. By the end of the degree, students will be prepared to enhance organizational reputation, drive customer loyalty, and excel in diverse service-based industries."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/human-resource-management",
                programImg: HumanResourceManagement,
                programLabel: "Human Resource Management",
                programText: "Gain comprehensive HR skills and theoretical grounding to thrive in organizational leadership and people operations.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 151,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This degree equips students with a deep understanding of human capital management, organizational psychology, and employment law. From talent acquisition and employee development to performance management and workplace culture, learners will develop both academic knowledge and practical skills for managing people in modern organizations. Graduates will be positioned to pursue careers in HR leadership or continue their studies in advanced business programs."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/project-management",
                programImg: projectManager,
                programLabel: "Project Management",
                programText: "Develop critical thinking and coordination skills to lead successful projects from inception to completion.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 144,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program provides a comprehensive academic foundation in project planning, budgeting, and execution. Students will study project lifecycles, risk analysis, and stakeholder communication while applying frameworks like Agile and Waterfall. The degree prepares graduates to handle complex business initiatives and opens doors to leadership opportunities or advanced studies in management disciplines."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/risk-management",
                programImg: risKManagement,
                programLabel: "Risk Management",
                programText: "Learn to identify, assess, and mitigate organizational risks in dynamic economic environments.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 108,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program focuses on the principles of risk assessment, crisis management, and corporate governance. Learners will gain insight into financial, operational, and strategic risks, with hands-on training in tools and frameworks used across industries. Graduates will develop strong analytical and decision-making abilities, enabling them to safeguard organizational value and adapt to uncertainty in global markets."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/sales-management",
                programImg: salesManagement,
                programLabel: "Sales Management",
                programText: "Develop strong foundational knowledge in sales strategy, leadership, and client relationship building.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 92,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This degree blends business theory with practical sales leadership training. Students will explore buyer psychology, pipeline management, and negotiation techniques while developing leadership skills for managing sales teams. With academic depth and real-world applications, graduates will be prepared to excel in competitive markets and advance into higher-level business studies or managerial roles."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/information-management",
                programImg: InformationManagement,
                programLabel: "Information Management",
                programText: "Build a solid academic base in managing data systems, digital records, and information flow across organizations.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 102,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This degree combines information science, data management, and organizational systems to prepare students for the digital workplace. Learners will study principles of IT infrastructure, cybersecurity basics, and data governance while applying theoretical frameworks to practical business scenarios. Graduates will be capable of managing modern information ecosystems and supporting innovation in diverse industries."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/supply-chain-management",
                programImg: SCM,
                programLabel: "Supply Chain Management",
                programText: "Understand global logistics, operations, and supplier networks in this hands-on degree built for future-ready professionals.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 72,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program integrates global trade principles with logistics, procurement, and operations management. Students will learn to optimize supply chains, manage vendor relationships, and leverage technology to improve efficiency. With case studies and simulations, the degree prepares graduates for impactful roles in multinational corporations and equips them for further specialization in logistics and operations."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/marketing",
                programImg: marketing,
                programLabel: "Marketing",
                programText: "Master essential marketing principles from branding to analytics, rooted in academic theory and market trends.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 148,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program develops expertise in consumer behavior, branding, and digital marketing strategies. Learners will explore market research, analytics, and campaign design, gaining both theoretical knowledge and practical skills. The degree opens doors to roles in advertising, public relations, and business development while laying a solid foundation for graduate-level studies in marketing and strategy."
            },
            {
                addToCart: false,
                projectPath: "/associate-bachelor-degree/accounting",
                programImg: accounting,
                programLabel: "Accounting",
                programText: "Build a thorough understanding of accounting standards, financial reporting, and managerial decision-making.",
                programPrice: "196",
                programPriceInNG: '300,000',
                programName: "ASSOCIATE BACHELOR'S DEGREE",
                programNamesOnCart: "Associate Bachelor's Degree",
                reviews: 86,
                duration: "2 Years",
                mode: "Online & Self-Paced",
                certificate: "Associate Bachelor's Degrees upon completion",
                note: "This program offers a strong academic foundation in accounting principles, auditing, and financial analysis. Students will master the use of accounting software while studying corporate finance, taxation, and ethical decision-making. By combining theory with hands-on practice, graduates will be prepared for entry-level roles in finance and accounting or continue their academic journey into bachelor’s and master’s level studies."
            }
        ]
    },
    {
        path: '/executive-mba',
        programName: 'EXECUTIVE MBA',
        programPrice: "490",
        heroImg: MBA,
        heroBigText: 'Lead with Impact Earn Your',
        heroBigText2: ' Online',
        heroBigTextColored: 'Executive MBA',
        heroSmallText:
            'Accelerate your leadership journey with advanced business training built for professionals.Flexible. Globally recognized. Career-transforming.',
        label: 'Explore Executive MBA Programs',
        programDetails: [
            {
                addToCart: false,
                projectPath: "/executive-mba/business-management",
                programImg: businessManagement,
                programLabel: "Business Management",
                programText: "Explore modern business leadership, sharpen your strategic thinking, and drive operational success across global industries.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 159,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "This program blends analytical and managerial expertise with real-world scenarios, equipping executives to lead effectively in a dynamic business world. You will strengthen your decision-making ability, master strategic growth frameworks, and develop the agility to manage people, resources, and innovation at scale. Designed for ambitious leaders, it prepares you to create value, build resilience, and thrive in global business environments."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/information-management",
                programImg: InformationManagement,
                programLabel: "Information Management",
                programText: "Build executive-level insight into data governance, system design, and information strategy for the modern enterprise.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 102,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "Prepare to lead in information-driven organizations with a curriculum that emphasizes digital ecosystems, data ethics, and scalable solutions. Beyond theory, the program explores cutting-edge technologies, cybersecurity protocols, and IT governance models. Graduates gain the skills to manage enterprise-wide information systems, optimize digital workflows, and shape organizational strategies for long-term success in a data-centric world."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/human-resource-management",
                programImg: HumanResourceManagement,
                programLabel: "Human Resource Management",
                programText: "Advance your HR leadership with executive-level training in talent strategy, workforce development, and organizational change.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 151,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "This program empowers senior HR professionals with tools to shape workplace culture, influence policy, and drive people-centered innovation. You’ll master executive-level strategies in employee engagement, change management, and labor relations while understanding the impact of HR on business performance. Graduates emerge ready to design future-ready organizations that align talent with growth and adaptability."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/accounting",
                programImg: accounting,
                programLabel: "Accounting",
                programText: "Gain strategic mastery of accounting systems, financial reporting, and executive-level fiscal analysis.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 86,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "Designed for professionals aiming to lead in finance, this program balances accounting theory with advanced tools and executive insights. You’ll build expertise in corporate finance, risk-based auditing, and international financial reporting standards. With a focus on strategic leadership, the curriculum equips you to influence boardroom decisions, ensure compliance, and drive fiscal sustainability at the highest level."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/risk-management",
                programImg: risKManagement,
                programLabel: "Risk Management",
                programText: "Navigate uncertainty with advanced knowledge in enterprise risk, compliance, and strategic mitigation planning.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 108,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "This program trains executives to assess, anticipate, and manage complex risks across global operations and industries. You will learn advanced frameworks for financial, operational, and reputational risk, as well as regulatory compliance. Through simulations and case studies, students gain the expertise to turn uncertainty into opportunity, strengthening organizational resilience and long-term sustainability."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/project-management",
                programImg: projectManagement,
                programLabel: "Project Management",
                programText: "Lead complex initiatives by mastering executive tools in planning, execution, budgeting, and agile delivery.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 144,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "The curriculum focuses on executive project leadership and the integration of cross-functional strategies for long-term success. Participants will refine their skills in strategic planning, agile management, and cross-border collaboration. Designed for leaders of large-scale initiatives, the program prepares you to deliver outcomes that align with corporate goals while managing budgets, teams, and risks effectively."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/marketing",
                programImg: marketing,
                programLabel: "Marketing",
                programText: "Design powerful marketing strategies and manage global campaigns through executive-level insight and analytics.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 148,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "This program develops senior marketing leaders with a sharp focus on branding, market behavior, digital trends, and customer experience. You’ll analyze global case studies, explore consumer psychology, and use advanced analytics to design innovative campaigns. The curriculum prepares you to lead creative and data-driven marketing teams, positioning brands for sustainable growth and competitive advantage worldwide."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/supply-chain-management",
                programImg: SCM,
                programLabel: "Supply Chain Management",
                programText: "Transform global logistics and supply networks through advanced planning, risk analysis, and tech-driven optimization.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 72,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "Train to lead global supply systems with a focus on resilience, cost-efficiency, sustainability, and operational excellence. The program combines logistics theory with emerging technologies such as AI, blockchain, and predictive analytics. Graduates develop the capacity to build future-ready supply chains that can withstand disruption while driving profitability and customer satisfaction."
            },
            {
                addToCart: false,
                projectPath: "/executive-mba/sales-management",
                programImg: salesManagement,
                programLabel: "Sales Management",
                programText: "Lead sales teams and drive revenue with executive-level expertise in customer engagement and performance strategy.",
                programPrice: "490",
                programPriceInNG: '750,000',
                programName: "EXECUTIVE MBA",
                programNamesOnCart: "Executive MBA",
                reviews: 92,
                duration: "6 Months - 2 Years",
                mode: "Online & Self-Paced",
                certificate: "Executive MBA certificate upon completion",
                note: "Focused on high-level sales leadership, this program combines behavioral science, analytics, and performance management to scale results. Students gain executive insight into customer psychology, digital sales transformation, and strategic negotiation. With practical simulations and leadership coaching, the program prepares you to drive revenue growth, inspire teams, and deliver consistent business performance."
            }
        ]
    },
    {
        path: '/mini-mba',
        programName: "EXECUTIVE MINI MBA",
        programNamesOnCart: "Executive Mini MBA",
        programPrice: "39",
        heroImg: MINI,
        heroBigText: 'Executive',
        heroBigText2: ' Everything You Need to Lead',
        heroBigTextColored: 'Mini MBA',
        heroSmallText:
            'Take the next big step in your career with our 2-month online Executive Mini MBA designed for professionals who want flexible, world-class business training without the high cost.',
        label: `Explore Executive Mini MBA's`,
        programDetails: [
            {
                addToCart: false,
                projectPath: '/mini-mba/business-management',
                programImg: businessManagement,
                programLabel: 'Business Management',
                programText:
                    'Master core business functions, leadership, and strategy to run or grow any organization effectively and confidently.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 97,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'A fast-tracked, high-impact business program designed to help professionals analyze operations, lead teams, and make data-informed decisions with confidence. You will connect strategy to execution, manage resources effectively, and apply practical frameworks that improve performance and accelerate career or business growth.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/project-management',
                programImg: projectManager,
                programLabel: 'Project Management',
                programText:
                    'Gain essential tools and leadership techniques to plan, execute, and deliver successful projects across industries.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 94,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Develop the capabilities to scope projects, allocate budgets, manage risks, and align stakeholders around clear deliverables. You will practice industry-standard methods (including agile principles), improve collaboration across functions, and consistently deliver outcomes on time and within budget in real-world settings.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/social-media-management',
                programImg: SMM,
                programLabel: 'Social Media Management',
                programText:
                    'Develop strategic social media skills for brand growth, audience engagement, and measurable marketing impact.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 87,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Learn to design platform-specific strategies, produce compelling content, and interpret analytics that drive measurable results. From community building to paid campaigns and reporting, you’ll gain the strategic and operational skills needed to grow brand visibility and convert engagement into tangible business outcomes.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/customer-service',
                programImg: CS,
                programLabel: 'Customer Service',
                programText:
                    'Learn to create outstanding customer experiences, handle complaints professionally, and boost client satisfaction.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 80,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Strengthen communication, empathy, and problem-solving to turn challenges into loyalty-building moments. You will learn escalation frameworks, feedback loops, and service metrics that improve retention, enhance brand reputation, and create consistent, high-quality experiences across all customer touchpoints.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/accounting',
                programImg: accounting,
                programLabel: 'Accounting',
                programText:
                    'Understand accounting principles, financial reporting, and analysis to support smart business decision-making.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 90,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Build confidence reading financial statements, managing budgets, and evaluating performance indicators that guide better decisions. You’ll translate numbers into insights, understand cost drivers, and apply practical accounting concepts that support planning, profitability, and long-term sustainability.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/marketing',
                programImg: marketing,
                programLabel: 'Marketing',
                programText:
                    'Build effective marketing strategies to reach audiences, increase brand awareness, and drive sales results.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 84,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Master the essentials of positioning, messaging, and funnel design, while using research and analytics to refine campaigns. You will craft strategies that attract, convert, and retain customers, integrating digital channels with practical tactics that deliver measurable, repeatable growth.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/human-resource-management',
                programImg: HumanResourceManagement,
                programLabel: 'Human Resource Management',
                programText:
                    'Strengthen HR skills in recruitment, training, and performance management to drive organizational success.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 85,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Design HR processes that attract top talent, build capability, and align performance with business goals. You will explore workforce planning, coaching frameworks, compliance basics, and culture-building practices that help teams thrive and organizations scale responsibly.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/supply-chain-management',
                programImg: SCM,
                programLabel: 'Supply Chain Management',
                programText:
                    'Learn logistics, procurement, and inventory control to successfully manage efficient, end-to-end supply chains.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 81,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Gain the skills to forecast demand, negotiate with vendors, and optimize inventory for cost and service. You will streamline processes from sourcing to delivery, build resilience against disruptions, and implement metrics that improve visibility and operational excellence across the chain.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/sales-management',
                programImg: salesManagement,
                programLabel: 'Sales Management',
                programText:
                    'Learn and master modern sales strategies, pipeline management, and negotiation to drive revenue and growth in any niche.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 92,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Build a repeatable sales engine by combining prospecting, qualification, forecasting, and coaching best practices. You will lead teams with clarity, leverage CRM insights to improve conversion, and design compensation and performance systems that scale results responsibly.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/risk-management',
                programImg: risKManagement,
                programLabel: 'Risk Management',
                programText:
                    'Learn to identify, assess, and manage business risks to protect and grow your organization. A core skill for any entrepreneur.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 83,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Develop a systematic approach to spotting vulnerabilities, prioritizing threats, and implementing controls that safeguard value. You will practice scenario planning, compliance alignment, and crisis response to ensure continuity and maintain stakeholder confidence in changing environments.'
            },
            {
                addToCart: false,
                projectPath: '/mini-mba/information-technology',
                programImg: IT,
                programLabel: 'Information Technology',
                programText:
                    'Understand IT systems, data security, and digital transformation for modern business operations in this digital age.',
                programPrice: "39",
                programPriceInNG: '60,000',
                programName: "EXECUTIVE MINI MBA",
                programNamesOnCart: "Executive Mini MBA",
                reviews: 96,
                duration: '2 Months',
                mode: 'Online & Self-Paced',
                certificate: 'Executive Mini MBA Certificate upon completion',
                note: 'Connect business goals to technology choices by exploring systems architecture, cybersecurity basics, and cloud-enabled workflows. You will evaluate digital tools, improve data stewardship, and champion transformation initiatives that increase efficiency, innovation, and competitive advantage.'
            },
        ],
    },
    {
        path: '/professional-certificate',
        programName: 'PROFESSIONAL COURSES',
        programPrice: "4",
        heroImg: PC,
        heroBigText: 'Get Certified in Just 14 Days with Our',
        heroBigTextColored: `Professional Online Courses`,
        heroSmallText: 'Upgrade your skills quickly with self-paced, expert-led courses. Fully online, flexible, and designed for busy professionals complete with a certificate you can showcase immediately.',
        label: 'Explore Professional Online Courses',
        programDetails: [
            {
                addToCart: false,
                projectPath: "/professional-certificate/fullstack-development",
                programImg: FS,
                programLabel: "Fullstack Development",
                programText: "Become a versatile fullstack developer by learning both frontend and backend technologies in an immersive, hands-on environment.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "574",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Fullstack Development",
                note: "This course is designed to turn you into a confident fullstack developer, capable of building complete web applications from scratch. You'll dive into both client-side and server-side programming, learn popular frameworks, and complete guided projects that reflect real-world challenges. Whether you're pivoting into tech or upskilling, this path ensures you're industry-ready with a well-rounded developer skill set."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/frontend-development",
                programImg: frontend,
                programLabel: "Frontend Development",
                programText: "Build visually stunning, user-centric web interfaces by mastering the tools and techniques of modern frontend development.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "748",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Frontend Development",
                note: "This intensive program focuses on frontend development essentials including HTML, CSS, JavaScript, and cutting-edge frameworks like React. Through structured lessons and portfolio projects, you’ll gain the skills to craft responsive and dynamic user experiences. By the end, you’ll not only understand how frontend systems work but also be able to collaborate effectively with designers and backend teams."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/ui-ux-design",
                programImg: UI,
                programLabel: "UI-UX Design",
                programText: "Craft seamless and engaging digital experiences with a deep dive into user interface and user experience design principles.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1984",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in UI-UX Design",
                note: "This course offers a practical and strategic approach to UI/UX design, blending design theory with real-life application. You'll explore usability, interaction design, wireframing, prototyping, and user research. By working on live design problems, you'll develop a designer’s mindset and the skills to create digital products that are both functional and aesthetically compelling. Perfect for aspiring designers or product creators looking to enhance usability and engagement."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/graphic-design",
                programImg: graphics,
                programLabel: "Graphic Design",
                programText: "Unleash your creativity and technical skills to produce visually compelling graphics across digital and print platforms.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "836",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Graphic Design",
                note: "Dive into the dynamic world of graphic design where creativity meets communication. This course teaches design fundamentals, branding, layout techniques, color theory, and industry-standard tools like Adobe Photoshop and Illustrator. Whether you're designing social media assets, marketing materials, or logos, you’ll walk away with a strong portfolio and the ability to turn ideas into striking visuals that captivate and inform."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/business--data-analyst",
                programImg: DA,
                programLabel: "Business - Data Analyst",
                programText: "Discover the analytical mindset and tools needed to turn raw business data into powerful strategic insights.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1728",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Business - Data Analyst",
                note: "This business-data analyst course combines technical instruction with real-world application to help you uncover trends and make data-driven decisions. You’ll learn how to collect, clean, and analyze data using tools like Excel, SQL, and Tableau. By working with datasets from multiple industries, you’ll develop the ability to communicate insights effectively and help organizations optimize their operations and growth strategies."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/iot-pro-course",
                programImg: IOT,
                programLabel: "IoT Pro Course",
                programText: "Step into the future of connectivity and automation with comprehensive training in Internet of Things (IoT) systems and applications.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1369",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in IoT Pro Course",
                note: "In this course, you'll explore the architecture, protocols, and hardware behind IoT systems. From smart homes to industrial sensors, you'll learn how IoT is transforming industries. Through hands-on labs and project development, you’ll gain the skills to build and manage IoT solutions that collect, transmit, and analyze data at scale. Ideal for tech professionals looking to specialize in this rapidly expanding field."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/blockchain-pro-course",
                programImg: blockchain,
                programLabel: "Blockchain Pro Course",
                programText: "Understand the revolutionary concepts behind blockchain technology and explore its applications beyond cryptocurrency.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1641",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Blockchain Pro Course",
                note: "This in-depth course demystifies blockchain by guiding you through its core principles, such as decentralization, cryptography, consensus models, and smart contracts. With real-world case studies and practice exercises, you'll build blockchain-based solutions and understand their use across industries like finance, logistics, and identity management. This is your gateway to one of the most disruptive innovations of our time."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/sql-pro-course",
                programImg: SQL,
                programLabel: "SQL Pro Course",
                programText: "Master SQL from beginner to advanced and gain the skills to manipulate, query, and analyze data effectively.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "874",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in SQL Pro Course",
                note: "This course walks you through structured query language (SQL) in detail from basic CRUD operations to complex joins, subqueries, and performance tuning. Whether you're managing databases or building reports, this course equips you to handle real-world data analysis tasks with confidence. You’ll also gain exposure to relational database management systems like MySQL and PostgreSQL, making this an essential toolkit for any data-driven career."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/devops-pro-course",
                programImg: devops,
                programLabel: "DevOps Pro Course",
                programText: "Gain the expertise to streamline software development and IT operations through DevOps practices and automation tools.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "370",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in DevOps Pro Course",
                note: "In this DevOps Pro Course, you'll dive into the philosophy and technical stack behind continuous integration, deployment pipelines, and infrastructure as code. From Docker and Kubernetes to Jenkins and GitHub Actions, you’ll learn how to build resilient systems that scale efficiently. This course is ideal for engineers looking to bridge development and operations for faster, more reliable product delivery."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/networking-programming-course",
                programImg: network,
                programLabel: "Networking Programming Course",
                programText: "Explore the foundations of computer networking and programming in one comprehensive, project-based learning experience.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1663",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Networking Programming Course",
                note: "Designed for those seeking to understand how systems communicate, this course covers the essentials of TCP/IP, routing, switching, and network security alongside Python-based scripting. You’ll apply your knowledge to build and troubleshoot networks, write automation scripts, and simulate data communication in real-world scenarios. Whether entering IT or cybersecurity, these are foundational skills you’ll rely on."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/cyber-security-pro-course",
                programImg: cyber,
                programLabel: "Cyber Security Pro Course",
                programText: "Defend digital assets and systems by mastering the essentials of cybersecurity operations and ethical hacking.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "245",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Cyber Security Pro Course",
                note: "This course provides a robust introduction to the core principles of cybersecurity, including threat identification, penetration testing, cryptography, and risk mitigation. With labs and simulated attacks, you’ll learn how to protect networks, secure information, and stay ahead of cyber threats. Ideal for aspiring security analysts or anyone working in tech who wants to strengthen their defense skills."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/microsoft-excel-pro-course",
                programImg: excel,
                programLabel: "Microsoft Excel Pro Course",
                programText: "Take control of data and boost your productivity by mastering the full capabilities of Microsoft Excel.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1602",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Microsoft Excel Pro Course",
                note: "Whether you’re working in finance, admin, analytics, or project management, Excel is a must-have tool. This course dives deep into formulas, pivot tables, data visualization, automation with macros, and real-life use cases. You’ll gain the ability to turn spreadsheets into decision-making tools and significantly enhance your productivity with practical business insights at your fingertips."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/power-bi-pro-course",
                programImg: powerBI,
                programLabel: "Power Bi  Pro Course",
                programText: "Transform data into actionable insights through advanced Power BI dashboards and real-time reporting solutions.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1428",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Power Bi  Pro Course",
                note: "This course equips you to build interactive dashboards, clean and model data, and leverage DAX to create meaningful KPIs and reports. From importing datasets to publishing insights for stakeholders, you’ll learn the end-to-end process of delivering business intelligence with Power BI. Perfect for professionals who need to tell data stories and support strategic decisions through powerful visualizations."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/dart-programming-course",
                programImg: dart,
                programLabel: "Dart Programming Course",
                programText: "Get started with modern app development by mastering Dart programming and its ecosystem, including Flutter integration.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1328",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Dart Programming Course",
                note: "Learn to code in Dart a fast-growing, object-oriented language used primarily for building mobile apps with Flutter. This course covers syntax, functions, OOP principles, and error handling through real-world app scenarios. Ideal for beginners and experienced coders looking to expand their toolkit for mobile-first development, this course sets the foundation for cross-platform success."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/programming-course",
                programImg: pro,
                programLabel: "Programming Course",
                programText: "Build a solid foundation in programming by exploring essential concepts and coding practices across multiple languages.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1576",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Programming Course",
                note: "This foundational course introduces students to core programming constructs such as loops, conditions, variables, functions, and data structures. Through hands-on exercises and mini-projects in languages like Python and JavaScript, you’ll develop the problem-solving mindset needed to succeed in any tech role. A perfect launchpad for beginners aiming to enter the world of software development."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/html-pro-course",
                programImg: html,
                programLabel: "HTML Pro Course",
                programText: "Unlock the full potential of HTML and learn how to build modern, responsive, and well-structured web pages from scratch.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "186",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in HTML Pro Course",
                note: "This course provides an in-depth exploration of HTML, the foundational language of the web. Through hands-on projects and interactive lessons, you'll learn not only the syntax but also how to structure semantic content, manage forms, embed media, and ensure accessibility. Whether you're new to coding or brushing up on web development basics, this course will strengthen your ability to create fast, clean, and professional-grade websites."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/python-pro-course",
                programImg: python,
                programLabel: "Python Pro Course",
                programText: "Explore Python's versatility and harness its power to solve real-world challenges in automation, data, and software development.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "392",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Python Pro Course",
                note: "This comprehensive course introduces Python programming in a way that’s approachable yet deeply practical. You'll gain a solid foundation in syntax and data structures while also diving into real-world applications such as automation, file handling, web scraping, and basic data analytics. With guided projects and hands-on exercises, learners develop the confidence and ability to write Python code that solves real business and technical problems effectively."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/react-native",
                programImg: reactNative,
                programLabel: "React Native",
                programText: "Build cross-platform mobile apps with ease using React Native and bring your ideas to both Android and iOS users.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1944",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in React Native",
                note: "Dive into the world of mobile app development with this powerful React Native course. It’s designed to help you understand core principles such as component-based architecture, state management, and device-native features like geolocation and camera access. With practical examples and real mobile application builds, you’ll gain the skills to build high-performance apps with elegant UIs and seamless user experiences for a wide audience."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/web-development",
                programImg: webDev,
                programLabel: "Web Development",
                programText: "Learn to develop modern, full-featured websites using industry-standard tools and practices in front-end and back-end development.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "488",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Web Development",
                note: "This course walks you through the essentials of building websites and web applications from the ground up. You’ll start with HTML, CSS, and JavaScript for the front end, and advance into back-end technologies like Node.js or databases. By combining theory with hands-on projects, learners leave with a portfolio-ready skill set and a solid grasp of modern development workflows, version control, and responsive design techniques that power today’s websites."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/cloud-computing",
                programImg: cloud,
                programLabel: "Cloud Computing",
                programText: "Master cloud infrastructure and services, and discover how to deploy, scale, and manage applications in a distributed environment.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "799",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Cloud Computing",
                note: "Explore the evolving world of cloud technology in this foundational course tailored for professionals looking to adapt to the future of computing. You’ll gain hands-on experience with cloud service models (IaaS, PaaS, SaaS), understand deployment frameworks, and explore cloud security, virtualization, and storage. This course empowers you with the know-how to migrate and manage systems in cloud platforms like AWS, Azure, or Google Cloud with confidence."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/artificial-intelligence",
                programImg: AI,
                programLabel: "Artificial Intelligence",
                programText: "Step into the realm of artificial intelligence and learn how to build systems that think, learn, and adapt.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1385",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Artificial Intelligence",
                note: "In this course, learners are introduced to the fascinating world of AI from machine learning algorithms to intelligent decision-making systems. You’ll explore supervised and unsupervised learning, neural networks, and real-life use cases such as recommendation engines and chatbots. This is more than just theory; each module comes with practical implementations using tools like Python and TensorFlow, preparing you for future roles in automation and intelligent system design."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/big-data",
                programImg: bigData,
                programLabel: "Big Data",
                programText: "Dive into the complexities of big data and learn how to collect, analyze, and visualize massive datasets effectively.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "431",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Big Data",
                note: "Designed for the data-driven professional, this course explores the tools and technologies needed to handle large-scale data. You’ll learn the principles of distributed systems like Hadoop and Spark, explore data ingestion pipelines, and gain exposure to structured and unstructured data handling. By the end of this course, you’ll be able to derive actionable insights from big data sets and support data-driven decision-making in any organization."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/data-science",
                programImg: dataScience,
                programLabel: "Data Science",
                programText: "Transform data into insights and drive intelligent decision-making through the power of data science.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1790",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Data Science",
                note: "This immersive course walks you through the entire data science pipeline, from data collection and cleaning to analysis and predictive modeling. Using Python and essential libraries like Pandas, NumPy, and Scikit-learn, you’ll build your understanding of statistical analysis, machine learning, and data visualization. Whether you’re entering the field or upskilling, this course gives you the edge to work with real data and build intelligent solutions that matter."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/social-media-management",
                programImg: SMM,
                programLabel: "Social Media Management",
                programText: "Develop the skills to strategize, manage, and grow powerful social media campaigns across major platforms.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "346",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Social Media Management",
                note: "This course delivers an actionable framework for mastering the tools and strategies needed in the fast-paced world of social media. You'll learn how to craft compelling content, manage brand identity, schedule posts with efficiency, and track engagement using industry-standard analytics tools. From organic growth to paid advertising, this course equips you to plan and execute high-converting campaigns on platforms like Facebook, Instagram, Twitter, LinkedIn, and TikTok. Ideal for aspiring digital marketers, brand managers, and entrepreneurs looking to amplify their digital presence."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/human-resource-management",
                programImg: HumanResourceManagement,
                programLabel: "Human Resource Management",
                programText: "Gain a thorough understanding of HR practices and learn how to lead, manage, and support a thriving workforce.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "963",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Human Resource Management",
                note: "This course is built for future HR leaders seeking to understand every facet of employee lifecycle management. You'll explore key HR functions such as recruitment, onboarding, performance evaluation, employee relations, compliance, and organizational culture. Through real-world scenarios and case studies, you’ll also gain insights into labor law, conflict resolution, compensation strategies, and leadership development. Whether you aim to join a corporate HR team or manage people within your business, this course provides essential tools for building and sustaining a productive workforce."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/product-management",
                programImg: projectManagement,
                programLabel: "Project Management",
                programText: "Learn how to initiate, plan, execute, and close successful projects on time and within budget.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1722",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Project Management",
                note: "This comprehensive course offers a deep dive into the principles and methodologies of modern project management. You’ll explore tools like Gantt charts, risk assessments, and stakeholder management strategies, while mastering frameworks such as Agile, Scrum, and Waterfall. Through simulations and guided exercises, you'll practice breaking down project requirements, building timelines, allocating resources, and managing teams. This course prepares you to lead projects of any size with confidence and clarity, making it ideal for managers, team leads, and coordinators across industries."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/customer-service",
                programImg: CS,
                programLabel: "Customer Service",
                programText: "Master the art of exceptional customer service and deliver positive experiences that build lasting brand loyalty.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1270",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Customer Service",
                note: "Designed for both front-line staff and team supervisors, this course focuses on delivering high-impact customer service in any business setting. You’ll learn the psychology of customer behavior, techniques for handling complaints, and methods to exceed expectations in both in-person and digital interactions. Using practical case studies, the course addresses tone, empathy, product knowledge, and crisis resolution strategies to turn frustrated clients into loyal advocates. Ideal for professionals who want to enhance their communication and customer handling skills."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/risk-management",
                programImg: risKManagement,
                programLabel: "Risk Management",
                programText: "Identify, assess, and mitigate risks with strategic planning tools that safeguard business goals.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "806",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Risk Management",
                note: "This course offers an analytical approach to recognizing, evaluating, and responding to a wide range of organizational risks. Whether it's financial, operational, compliance-based, or reputational, you’ll gain the skills needed to perform risk assessments and implement mitigation strategies. You'll also explore the use of risk matrices, audits, control systems, and compliance standards like ISO 31000. With real-life case studies and actionable frameworks, this course prepares professionals to make informed decisions that protect and sustain business value."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/marketing",
                programImg: marketing,
                programLabel: "Marketing",
                programText: "Learn how to attract, engage, and convert audiences using modern marketing principles and strategies.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1906",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Marketing",
                note: "Dive into the full spectrum of marketing fundamentals, from understanding consumer behavior to executing cross-channel campaigns. This course covers both digital and traditional marketing techniques, including branding, copywriting, SEO, email marketing, influencer campaigns, and performance analytics. You’ll also explore segmentation, targeting, and positioning to design strategies that drive real business growth. Perfect for marketers, entrepreneurs, or anyone looking to master the art of persuasion and brand visibility in a competitive marketplace."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/accounting",
                programImg: accounting,
                programLabel: "Accounting",
                programText: "Build a solid foundation in accounting principles, financial reporting, and business budgeting essentials.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "268",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Accounting",
                note: "This beginner-friendly course demystifies accounting concepts and introduces learners to the language of business finance. You'll understand how to read financial statements, track revenue and expenses, and calculate key performance indicators. Topics include double-entry bookkeeping, ledgers, trial balances, and profit/loss analysis. Practical exercises reinforce your knowledge of budgeting and tax considerations. Whether you’re preparing for a role in finance or simply want to manage your personal or business accounts more effectively, this course delivers core competencies that matter."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/sales-management",
                programImg: salesManagement,
                programLabel: "Sales Management",
                programText: "Discover how to lead high-performing sales teams and drive consistent revenue growth through strategy and motivation.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1565",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Sales Management",
                note: "This course teaches you how to build, motivate, and manage sales teams using proven methodologies. You’ll gain insight into pipeline forecasting, performance metrics, sales coaching, and negotiation strategies. You'll also explore CRM tools and digital sales platforms that streamline prospecting and follow-ups. Perfect for aspiring sales managers or entrepreneurs, this course helps you align sales objectives with business goals, manage team morale, and close deals effectively in fast-paced environments."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/information-technology",
                programImg: IT,
                programLabel: "Information Technology",
                programText: "Explore IT systems, networking, and security while building hands-on skills to support enterprise-level tech environments.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "255",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Information Technology",
                note: "This course is a complete guide to understanding the foundations of modern IT infrastructure. It covers networking basics, system administration, database management, cloud integration, and cybersecurity protocols. You’ll also learn how to troubleshoot hardware/software issues, configure devices, and maintain secure IT environments. This practical course is designed for tech enthusiasts, office managers, or anyone seeking a career path in IT support, systems analysis, or network management."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/supply-chain-management",
                programImg: SCM,
                programLabel: "Supply Chain Management",
                programText: "Understand the flow of goods, information, and services to optimize operations across the entire supply chain.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "421",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Supply Chain Management",
                note: "This course provides a practical and strategic overview of supply chain operations, covering procurement, logistics, inventory control, demand planning, and supplier relationship management. You’ll explore global sourcing strategies, warehouse systems, distribution networks, and how data drives decision-making in modern supply chains. With hands-on simulations and industry case studies, learners develop the ability to enhance efficiency, reduce costs, and manage risks in complex supply networks skills that are vital in today's interconnected business world."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/product-management",
                programImg: projectManagement,
                programLabel: "Product Management",
                programText: "Lead the creation and growth of successful products by mastering the tools and mindset of a product manager.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1722",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Product Management",
                note: "This course immerses you in the lifecycle of product development, from idea generation and market research to launch and optimization. You’ll gain skills in stakeholder communication, roadmap planning, feature prioritization, and agile methodologies. Whether working with engineers, designers, or marketing teams, you’ll learn to align cross-functional efforts toward user-centered solutions. This program equips aspiring product managers with a strategic toolkit to lead innovation, measure impact, and build products that deliver lasting value in dynamic markets."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/product-design",
                programImg: pd,
                programLabel: "Product Design",
                programText: "Combine creativity and usability to design products that are intuitive, impactful, and user-focused.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1239",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Product Design",
                note: "This hands-on course explores the full spectrum of product design from user research and wireframing to visual aesthetics and interaction design. You'll dive into tools like Figma or Sketch, apply design thinking principles, and test your ideas through prototyping and user feedback. Emphasis is placed on creating accessible, functional, and beautiful interfaces that solve real problems. Ideal for aspiring designers, this course helps you build a portfolio while sharpening the critical thinking and creativity needed to thrive in tech and product-driven industries."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/design-thinking",
                programImg: dt,
                programLabel: "Design Thinking",
                programText: "Discover how to solve complex problems creatively through human-centered design approaches and innovation frameworks.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "439",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Design Thinking",
                note: "This immersive course guides learners through each stage of the design thinking process from empathizing with users to prototyping solutions and testing ideas. You’ll explore real-world case studies, ideation techniques, and collaborative problem-solving strategies that foster creativity, agility, and innovation. Whether you're in tech, education, or entrepreneurship, this course provides practical tools for designing impactful and user-driven solutions."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/brand-management",
                programImg: bm,
                programLabel: "Brand Management",
                programText: "Build and grow powerful brands through strategic storytelling, visual identity, and market positioning.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1997",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Brand Management",
                note: "This course explores the mechanics of building successful brands that resonate with audiences and stand out in competitive markets. You'll learn how to define brand voice, manage perception, create campaigns, and monitor brand equity. With examples from global companies and exercises in brand storytelling, positioning, and consistency, this course equips learners with the tools to manage brands that thrive and evolve over time."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/laravel-programming",
                programImg: laravel,
                programLabel: "Laravel Programming",
                programText: "Create robust, scalable, and secure web applications using Laravel’s powerful PHP framework.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "257",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Laravel Programming",
                note: "Learn how to build dynamic and secure web apps using Laravel, one of the most popular PHP frameworks. This course covers routing, middleware, Blade templating, database migrations, and RESTful API development. With real-world projects and a hands-on approach, you’ll gain the skills to architect modern applications efficiently while maintaining clean, testable code."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/java-programming",
                programImg: java,
                programLabel: "Java Programming",
                programText: "Master Java’s object-oriented principles and build powerful applications across desktop, web, and mobile platforms.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "501",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Java Programming",
                note: "This course offers an in-depth journey into Java programming, from variables and control structures to advanced topics like multithreading and file I/O. You’ll work on mini-projects that mimic enterprise-level development and learn how to debug, refactor, and optimize Java code. Whether you're building software, Android apps, or backend services, this course sets a strong foundation for long-term success."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/payroll-management",
                programImg: payroll,
                programLabel: "Payroll Management",
                programText: "Streamline payroll operations and ensure compliance with tax and labor regulations effectively.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1935",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Payroll Management",
                note: "Gain the knowledge and tools to manage payroll systems with accuracy and legal compliance. This course covers salary structure, statutory deductions, employee benefits, tax filing, and payroll software operations. It’s designed to help HR professionals and finance personnel reduce errors, improve reporting, and ensure employees are paid accurately and on time."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/customer-relationship-management",
                programImg: crm,
                programLabel: "Customer Relationship Management",
                programText: "Develop strategies to build long-term customer relationships and drive loyalty with CRM systems.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1729",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Customer Relationship Management",
                note: "This course explores the fundamentals of CRM and how to implement systems that improve customer engagement and retention. You’ll learn about CRM tools, customer segmentation, personalized outreach, and sales funnel optimization. Perfect for marketers, sales reps, and business owners looking to cultivate strong client relationships that drive recurring revenue."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/banking-and-finance",
                programImg: bf,
                programLabel: "Banking and Finance",
                programText: "Explore core principles of banking systems, financial instruments, and global economic operations.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1234",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Banking and Finance",
                note: "Learn how financial institutions operate, how monetary policy impacts markets, and how investment instruments are used in personal and corporate finance. This course covers commercial banking, lending practices, capital markets, risk management, and financial planning. Ideal for finance professionals, analysts, and anyone entering the banking sector."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/compensation-and-benefits",
                programImg: cb,
                programLabel: "Compensation and Benefits",
                programText: "Design and manage fair, competitive, and motivating compensation structures for today’s workforce.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1641",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Compensation and Benefits",
                note: "This course provides HR professionals with the knowledge to build sustainable salary structures, incentive programs, and employee benefits plans. Topics include internal equity, external competitiveness, job evaluation, and pay-for-performance models. You'll also learn how to navigate laws and compliance issues while keeping employee satisfaction and company goals in balance."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/performance-appraisal",
                programImg: pa,
                programLabel: "Performance Appraisal",
                programText: "Evaluate employee performance effectively with structured feedback systems and goal tracking.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "920",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Performance Appraisal",
                note: "This course teaches managers and HR specialists how to design and implement performance appraisal systems that drive accountability and growth. You'll explore KPI setting, 360-degree feedback, performance reviews, and strategies for coaching underperformers. By the end, you’ll be able to turn evaluations into actionable development plans."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/talent-acquisition",
                programImg: ta,
                programLabel: "Talent Acquisition",
                programText: "Recruit, assess, and onboard top talent using effective sourcing and selection strategies.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "720",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Talent Acquisition",
                note: "This course covers every stage of modern recruitment from writing compelling job descriptions and sourcing candidates to interviewing and onboarding. You'll explore tools like ATS systems, recruitment marketing, behavioral assessments, and metrics for measuring hiring effectiveness. It's perfect for HR professionals and hiring managers who want to attract and retain high-caliber talent."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/hr-analytics",
                programImg: hr,
                programLabel: "HR Analytics",
                programText: "Leverage data and analytics to drive strategic HR decisions and optimize workforce performance.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1484",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in HR Analytics",
                note: "This course empowers HR professionals to make data-driven decisions by teaching how to collect, interpret, and apply workforce metrics. You’ll learn predictive analytics, attrition modeling, employee engagement analysis, and performance trend tracking. With hands-on projects using real HR data, this course enhances your ability to influence organizational growth through measurable people insights."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/public-health",
                programImg: ph,
                programLabel: "Public Health",
                programText: "Understand the principles and challenges of promoting health and preventing disease in communities.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "832",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Public Health",
                note: "This course introduces key topics in global and local public health, including disease prevention, health education, epidemiology, and policy-making. You'll explore real-world health case studies, learn to assess population needs, and design impactful interventions. Whether you're pursuing a career in healthcare or nonprofit work, this program prepares you to make a difference at the community level."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/content-writing",
                programImg: content,
                programLabel: "Content Writing",
                programText: "Craft compelling and purposeful content for blogs, websites, social media, and marketing campaigns.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1338",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Content Writing",
                note: "This course equips aspiring writers with the skills to plan, structure, and write effective digital content. From storytelling to SEO best practices, you'll learn how to adapt tone for different platforms and engage your target audience. You'll also complete writing challenges and receive feedback to sharpen your technique, making you job-ready for freelance or corporate writing roles."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/pinterest-marketing",
                programImg: pinterest,
                programLabel: "Pinterest Marketing",
                programText: "Tap into Pinterest's visual power to build brand awareness and drive targeted traffic to your business.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "887",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Pinterest Marketing",
                note: "Learn how to create optimized Pins, boards, and strategies that turn Pinterest into a high-converting traffic engine. This course covers keyword research, audience targeting, content calendars, and using analytics to grow your reach. Whether you're promoting products or blog content, you'll leave equipped to create a Pinterest presence that delivers real results."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/audit-and-internal-control-management",
                programImg: aicm,
                programLabel: "Audit and Internal Control Management",
                programText: "Master auditing techniques and internal control frameworks to strengthen organizational integrity.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "255",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Audit and Internal Control Management",
                note: "This course provides an in-depth look at auditing procedures, risk management, compliance, and control systems. You’ll learn to design audit programs, detect irregularities, and evaluate internal policies for efficiency and transparency. Ideal for accounting professionals and compliance officers, this course builds critical skills for maintaining accountability and preventing fraud."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/fintech-management",
                programImg: Fintech,
                programLabel: "Fintech Management",
                programText: "Navigate the evolving world of digital finance, blockchain, and financial innovation with confidence.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "407",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Fintech Management",
                note: "Dive into the fast-growing fintech sector and learn how emerging technologies are reshaping payments, lending, investment, and banking. You’ll explore blockchain, digital wallets, robo-advisors, and regulatory technology, with case studies from top fintech firms. This course equips you to lead or collaborate in tech-driven finance environments where innovation meets regulation."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/communications-management",
                programImg: ccm,
                programLabel: "Communications Management",
                programText: "Build and deliver effective internal and external communications in professional environments.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "724",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Communications Management",
                note: "This course covers the principles of corporate communication, stakeholder engagement, and strategic messaging. You’ll learn how to manage PR crises, lead communications in project teams, write clear business documents, and use digital platforms for outreach. It's ideal for professionals aiming to influence, inform, and connect through purposeful communication."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/operations-management",
                programImg: om,
                programLabel: "Operations Management",
                programText: "Streamline business operations by improving processes, productivity, and resource utilization.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "287",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Operations Management",
                note: "This course teaches the fundamentals of operations from process analysis and workflow optimization to inventory control and supply chain alignment. You’ll apply techniques like Lean, Six Sigma, and continuous improvement to real-world business scenarios. It’s suited for professionals looking to boost efficiency, reduce waste, and enhance overall operational performance."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/business-management",
                programImg: businessManagement,
                programLabel: "Business Management",
                programText: "Lead teams, manage resources, and make strategic decisions to drive business success.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "277",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Business Management",
                note: "This course provides a broad foundation in management principles including leadership, finance, operations, and organizational behavior. You’ll explore how to set goals, manage conflict, assess performance, and adapt to change in dynamic environments. Perfect for aspiring managers or entrepreneurs seeking a solid grasp of business fundamentals."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/property-and-asset-management",
                programImg: pam,
                programLabel: "Property and Asset Management",
                programText: "Manage real estate portfolios and physical assets for long-term growth and operational efficiency.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1907",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Property and Asset Management",
                note: "This course dives into property lifecycle management, including acquisition, maintenance, valuation, leasing, and divestment. You'll learn to develop asset strategies, evaluate property risks, and oversee tenant relations. With insights from both real estate and facilities management, this course prepares professionals to enhance value while minimizing operational costs."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/monitoring-and-evaluation",
                programImg: me,
                programLabel: "Monitoring and Evaluation",
                programText: "Develop strong analytical skills to track project progress, assess impact, and optimize performance.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1990",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Monitoring and Evaluation",
                note: "This course offers practical insights into designing monitoring systems and evaluation frameworks that help organizations make informed, evidence-based decisions. You'll gain expertise in data collection tools, performance indicators, and result-based reporting, preparing you for roles in NGOs, government, or corporate project oversight."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/digital-marketing",
                programImg: dm,
                programLabel: "Digital Marketing",
                programText: "Create and manage effective digital campaigns using SEO, social media, PPC, and content strategy.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1850",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Digital Marketing",
                note: "This course equips you with a full digital marketing toolkit SEO, Google Ads, content marketing, and more tailored for real-world business goals. Learn how to build customer funnels, boost conversions, and analyze performance using modern tools and data. Ideal for business owners, marketers, and freelancers."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/copywriting",
                programImg: Copywriting,
                programLabel: "Copywriting",
                programText: "Write persuasive, engaging copy that converts audiences into loyal customers.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "494",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Copywriting",
                note: "Master the psychology of words and how to craft attention-grabbing headlines, email campaigns, landing pages, and ads. You'll explore storytelling, emotional triggers, and brand voice development while building a portfolio of compelling work. Perfect for marketers, entrepreneurs, and content creators."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/procurement",
                programImg: Procurement,
                programLabel: "Procurement",
                programText: "Gain the expertise to source suppliers, negotiate contracts, and manage purchasing processes efficiently.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "263",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Procurement",
                note: "This course dives into supplier selection, cost management, contract law, and purchasing ethics. Learn how to optimize procurement cycles, implement e-procurement tools, and align sourcing with business goals. Ideal for supply chain professionals and aspiring procurement managers."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/office-administration",
                programImg: oa,
                programLabel: "Office Administration",
                programText: "Run efficient office operations and support organizational success with administrative expertise.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "358",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Office Administration",
                note: "This course equips learners with skills in office organization, records management, scheduling, and basic HR and finance tasks. You’ll master digital tools, communication techniques, and workflow optimization, making you a key support pillar in any workplace setting."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/hospitality-management",
                programImg: Hospitality,
                programLabel: "Hospitality Management",
                programText: "Master service excellence, guest relations, and operational leadership in the hospitality industry.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "764",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Hospitality Management",
                note: "From front desk operations to event planning, this course teaches the foundations of hotel, resort, and restaurant management. Learn about customer service, quality assurance, budgeting, and staff coordination to build a thriving hospitality environment."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/hse-management",
                programImg: HSE,
                programLabel: "HSE Management",
                programText: "Promote workplace safety and environmental compliance through strategic HSE leadership.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "249",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in HSE Management",
                note: "This course covers risk assessment, occupational health regulations, safety planning, and environmental controls. You’ll gain practical tools for accident prevention, incident response, and audits essential for HSE officers, facility managers, and engineers in high-risk industries."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/financial-management",
                programImg: fm,
                programLabel: "Financial Management",
                programText: "Analyze financial data, plan budgets, and guide businesses toward smart fiscal decisions.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "938",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Financial Management",
                note: "You’ll learn how to interpret financial statements, manage cash flows, evaluate investments, and create strategic budgets. This course helps business leaders and finance professionals control risk, drive profitability, and align spending with long-term goals."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/warehouse-management",
                programImg: Warehouse,
                programLabel: "Warehouse Management",
                programText: "Streamline inventory, optimize space, and coordinate warehouse operations for peak efficiency.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "101",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Warehouse Management",
                note: "Gain hands-on knowledge of receiving, storage systems, picking, packing, and order fulfillment. Learn best practices in layout planning, stock control, and warehouse software to minimize errors and maximize productivity in modern logistics."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/logistics-management",
                programImg: Logistics,
                programLabel: "Logistics Management",
                programText: "Coordinate supply chain activities, transportation, and delivery systems with precision.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "143",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Logistics Management",
                note: "This course explores shipping methods, third-party logistics, tracking systems, and demand forecasting. You’ll develop operational strategies that reduce delays and improve delivery reliability essential for logistics coordinators and managers."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/materials-management",
                programImg: Materials,
                programLabel: "Materials Management",
                programText: "Develop a strong command of materials flow, procurement, and resource allocation to streamline business operations.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1427",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Materials Management",
                note: "This course trains professionals to manage materials and supplies effectively within any organization. It covers key areas such as stock level control, procurement planning, logistics coordination, and waste reduction   all aimed at improving operational efficiency and reducing overhead costs."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/inventory-management",
                programImg: Inventory,
                programLabel: "Inventory Management",
                programText: "Gain hands-on skills to track, optimize, and manage inventory systems across diverse industries.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1492",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Inventory Management",
                note: "This course explores inventory strategies such as FIFO/LIFO methods, automated systems, auditing techniques, and demand forecasting. Learners will understand how to avoid stockouts, minimize excess inventory, and build systems that align with real-time supply chain goals."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/wordpress-operations-pro",
                programImg: wordpress,
                programLabel: "WordPress Operations Pro",
                programText: "Build powerful, responsive websites using WordPress with a focus on backend operations, content workflows, and plugin architecture.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "125",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in WordPress Operations Pro",
                note: "This course is tailored to help learners master both the visible and behind-the-scenes operations of WordPress. From installing and configuring plugins to automating publishing processes and optimizing for performance, participants will gain practical skills that empower them to create and manage high-functioning websites for business or freelance purposes."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/product-analytics",
                programImg: productAnalysis,
                programLabel: "Product Analytics",
                programText: "Unlock the power of product data by learning analytics techniques that drive smarter product decisions and user growth.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "185",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Product Analytics",
                note: "Dive into a curriculum designed to teach you how to measure product performance using key metrics, interpret behavioral trends, and generate insights that influence product roadmaps. This course empowers learners to make data-backed decisions, identify churn points, and optimize the user experience in real-world business contexts."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/instagram-marketing-and-management",
                programImg: instagram,
                programLabel: "Instagram Marketing & Management",
                programText: "Master the art of growing and managing Instagram accounts for brands, influencers, and campaigns with strategic insight.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "934",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Instagram Marketing & Management",
                note: "This course walks you through Instagram content strategy, analytics, ad management, and influencer collaborations. Learners will explore real case studies, learn algorithm hacks, and practice storytelling methods that convert followers into loyal customers   all within the Instagram ecosystem."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/facebook-ads-and-management",
                programImg: facebook,
                programLabel: "Facebook Ads and Management",
                programText: "Become proficient in Facebook advertising and page management to run data-driven campaigns that maximize ROI.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1395",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Facebook Ads and Management",
                note: "This hands-on course covers the full spectrum of Facebook Ads from creating ad creatives and setting up pixel tracking to targeting audiences and analyzing ad reports. Learners will gain the tools and templates to manage ad accounts, scale campaigns efficiently, and drive measurable growth for businesses or clients."
            },
            {
                addToCart: false,
                projectPath: "/professional-certificate/twitter-operations-and-management",
                programImg: twitter,
                programLabel: "Twitter Operations and Management",
                programText: "Learn to manage Twitter accounts with an edge through content planning, trends leverage, and engagement analytics.",
                programPrice: "4",
                programPriceInNG: '5,000',
                programName: "PROFESSIONAL COURSES",
                programNamesOnCart: "Professional Courses",
                reviews: "1578",
                duration: "14 days",
                mode: "Online & Self-Paced",
                certificate: "Professional Certificate in Twitter Operations and Management",
                note: "This course equips learners with the tactical know-how to run high-performing Twitter profiles. From creating viral threads and Twitter Spaces to handling brand crisis communication, you’ll master how to grow an audience and maintain a professional, responsive Twitter presence tailored for success in digital communications."
            }
        ]
    },
    {
        path: '/executive-diploma',
        programName: 'EXECUTIVE DIPLOMA',
        programPrice: "10",
        heroImg: ED,
        heroBigText: 'Accelerate Your Career with a 1-Month',
        heroBigTextColored: `Executive Diploma`,
        heroSmallText: 'Advance your business skills through a 1-month, self-paced online program. Earn a recognized Executive Diploma Certificate and boost your credibility in just 30 days.',
        label: 'Explore Executive Diploma’s',
        programDetails: [
            {
                addToCart: false,
                projectPath: "/executive-diploma/fullstack-development",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: FS,
                programLabel: "Fullstack Development",
                programText: "Become a versatile fullstack developer by learning both frontend and backend technologies in an immersive, hands-on environment.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1494",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in fullstack-development",
                note: "This course is designed to turn you into a confident fullstack developer, capable of building complete web applications from scratch. You'll dive into both client-side and server-side programming, learn popular frameworks, and complete guided projects that reflect real-world challenges. Whether you're pivoting into tech or upskilling, this path ensures you're industry-ready with a well-rounded developer skill set."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/frontend-development",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: frontend,
                programLabel: "Frontend Development",
                programText: "Build visually stunning, user-centric web interfaces by mastering the tools and techniques of modern frontend development.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "124",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in frontend-development",
                note: "This intensive program focuses on frontend development essentials including HTML, CSS, JavaScript, and cutting-edge frameworks like React. Through structured lessons and portfolio projects, you’ll gain the skills to craft responsive and dynamic user experiences. By the end, you’ll not only understand how frontend systems work but also be able to collaborate effectively with designers and backend teams."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/ui-ux-design",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: UI,
                programLabel: "UI-UX Design",
                programText: "Craft seamless and engaging digital experiences with a deep dive into user interface and user experience design principles.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "623",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in ui-ux-design",
                note: "This course offers a practical and strategic approach to UI/UX design, blending design theory with real-life application. You'll explore usability, interaction design, wireframing, prototyping, and user research. By working on live design problems, you'll develop a designer’s mindset and the skills to create digital products that are both functional and aesthetically compelling. Perfect for aspiring designers or product creators looking to enhance usability and engagement."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/graphic-design",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: graphics,
                programLabel: "Graphic Design",
                programText: "Unleash your creativity and technical skills to produce visually compelling graphics across digital and print platforms.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1752",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in graphic-design",
                note: "Dive into the dynamic world of graphic design where creativity meets communication. This course teaches design fundamentals, branding, layout techniques, color theory, and industry-standard tools like Adobe Photoshop and Illustrator. Whether you're designing social media assets, marketing materials, or logos, you’ll walk away with a strong portfolio and the ability to turn ideas into striking visuals that captivate and inform."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/business--data-analyst",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: DA,
                programLabel: "Business - Data Analyst",
                programText: "Discover the analytical mindset and tools needed to turn raw business data into powerful strategic insights.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1356",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in business---data-analyst",
                note: "This business-data analyst course combines technical instruction with real-world application to help you uncover trends and make data-driven decisions. You’ll learn how to collect, clean, and analyze data using tools like Excel, SQL, and Tableau. By working with datasets from multiple industries, you’ll develop the ability to communicate insights effectively and help organizations optimize their operations and growth strategies."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/iot-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: IOT,
                programLabel: "IoT Pro Course",
                programText: "Step into the future of connectivity and automation with comprehensive training in Internet of Things (IoT) systems and applications.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1287",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in iot-pro-course",
                note: "In this course, you'll explore the architecture, protocols, and hardware behind IoT systems. From smart homes to industrial sensors, you'll learn how IoT is transforming industries. Through hands-on labs and project development, you’ll gain the skills to build and manage IoT solutions that collect, transmit, and analyze data at scale. Ideal for tech professionals looking to specialize in this rapidly expanding field."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/blockchain-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: blockchain,
                programLabel: "Blockchain Pro Course",
                programText: "Understand the revolutionary concepts behind blockchain technology and explore its applications beyond cryptocurrency.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "295",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in blockchain-pro-course",
                note: "This in-depth course demystifies blockchain by guiding you through its core principles, such as decentralization, cryptography, consensus models, and smart contracts. With real-world case studies and practice exercises, you'll build blockchain-based solutions and understand their use across industries like finance, logistics, and identity management. This is your gateway to one of the most disruptive innovations of our time."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/sql-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: SQL,
                programLabel: "SQL Pro Course",
                programText: "Master SQL from beginner to advanced and gain the skills to manipulate, query, and analyze data effectively.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "649",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in sql-pro-course",
                note: "This course walks you through structured query language (SQL) in detail from basic CRUD operations to complex joins, subqueries, and performance tuning. Whether you're managing databases or building reports, this course equips you to handle real-world data analysis tasks with confidence. You’ll also gain exposure to relational database management systems like MySQL and PostgreSQL, making this an essential toolkit for any data-driven career."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/devops-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: devops,
                programLabel: "DevOps Pro Course",
                programText: "Gain the expertise to streamline software development and IT operations through DevOps practices and automation tools.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "280",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in devops-pro-course",
                note: "In this DevOps Pro Course, you'll dive into the philosophy and technical stack behind continuous integration, deployment pipelines, and infrastructure as code. From Docker and Kubernetes to Jenkins and GitHub Actions, you’ll learn how to build resilient systems that scale efficiently. This course is ideal for engineers looking to bridge development and operations for faster, more reliable product delivery."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/networking-programming-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: network,
                programLabel: "Networking Programming Course",
                programText: "Explore the foundations of computer networking and programming in one comprehensive, project-based learning experience.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "409",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in networking-programming-course",
                note: "Designed for those seeking to understand how systems communicate, this course covers the essentials of TCP/IP, routing, switching, and network security alongside Python-based scripting. You’ll apply your knowledge to build and troubleshoot networks, write automation scripts, and simulate data communication in real-world scenarios. Whether entering IT or cybersecurity, these are foundational skills you’ll rely on."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/cyber-security-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: cyber,
                programLabel: "Cyber Security Pro Course",
                programText: "Defend digital assets and systems by mastering the essentials of cybersecurity operations and ethical hacking.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "851",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in cyber-security-pro-course",
                note: "This course provides a robust introduction to the core principles of cybersecurity, including threat identification, penetration testing, cryptography, and risk mitigation. With labs and simulated attacks, you’ll learn how to protect networks, secure information, and stay ahead of cyber threats. Ideal for aspiring security analysts or anyone working in tech who wants to strengthen their defense skills."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/microsoft-excel-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: excel,
                programLabel: "Microsoft Excel Pro Course",
                programText: "Take control of data and boost your productivity by mastering the full capabilities of Microsoft Excel.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "410",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in microsoft-excel-pro-course",
                note: "Whether you’re working in finance, admin, analytics, or project management, Excel is a must-have tool. This course dives deep into formulas, pivot tables, data visualization, automation with macros, and real-life use cases. You’ll gain the ability to turn spreadsheets into decision-making tools and significantly enhance your productivity with practical business insights at your fingertips."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/power-bi-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: powerBI,
                programLabel: "Power Bi  Pro Course",
                programText: "Transform data into actionable insights through advanced Power BI dashboards and real-time reporting solutions.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1264",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in power-bi--pro-course",
                note: "This course equips you to build interactive dashboards, clean and model data, and leverage DAX to create meaningful KPIs and reports. From importing datasets to publishing insights for stakeholders, you’ll learn the end-to-end process of delivering business intelligence with Power BI. Perfect for professionals who need to tell data stories and support strategic decisions through powerful visualizations."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/dart-programming-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: dart,
                programLabel: "Dart Programming Course",
                programText: "Get started with modern app development by mastering Dart programming and its ecosystem, including Flutter integration.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "441",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in dart-programming-course",
                note: "Learn to code in Dart a fast-growing, object-oriented language used primarily for building mobile apps with Flutter. This course covers syntax, functions, OOP principles, and error handling through real-world app scenarios. Ideal for beginners and experienced coders looking to expand their toolkit for mobile-first development, this course sets the foundation for cross-platform success."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/programming-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: pro,
                programLabel: "Programming Course",
                programText: "Build a solid foundation in programming by exploring essential concepts and coding practices across multiple languages.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1685",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in programming-course",
                note: "This foundational course introduces students to core programming constructs such as loops, conditions, variables, functions, and data structures. Through hands-on exercises and mini-projects in languages like Python and JavaScript, you’ll develop the problem-solving mindset needed to succeed in any tech role. A perfect launchpad for beginners aiming to enter the world of software development."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/html-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: html,
                programLabel: "HTML Pro Course",
                programText: "Unlock the full potential of HTML and learn how to build modern, responsive, and well-structured web pages from scratch.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "783",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in html-pro-course",
                note: "This course provides an in-depth exploration of HTML, the foundational language of the web. Through hands-on projects and interactive lessons, you'll learn not only the syntax but also how to structure semantic content, manage forms, embed media, and ensure accessibility. Whether you're new to coding or brushing up on web development basics, this course will strengthen your ability to create fast, clean, and professional-grade websites."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/python-pro-course",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: python,
                programLabel: "Python Pro Course",
                programText: "Explore Python's versatility and harness its power to solve real-world challenges in automation, data, and software development.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1988",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in python-pro-course",
                note: "This comprehensive course introduces Python programming in a way that’s approachable yet deeply practical. You'll gain a solid foundation in syntax and data structures while also diving into real-world applications such as automation, file handling, web scraping, and basic data analytics. With guided projects and hands-on exercises, learners develop the confidence and ability to write Python code that solves real business and technical problems effectively."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/react-native",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: reactNative,
                programLabel: "React Native",
                programText: "Build cross-platform mobile apps with ease using React Native and bring your ideas to both Android and iOS users.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "303",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in react-native",
                note: "Dive into the world of mobile app development with this powerful React Native course. It’s designed to help you understand core principles such as component-based architecture, state management, and device-native features like geolocation and camera access. With practical examples and real mobile application builds, you’ll gain the skills to build high-performance apps with elegant UIs and seamless user experiences for a wide audience."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/web-development",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: webDev,
                programLabel: "Web Development",
                programText: "Learn to develop modern, full-featured websites using industry-standard tools and practices in front-end and back-end development.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "436",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in web-development",
                note: "This course walks you through the essentials of building websites and web applications from the ground up. You’ll start with HTML, CSS, and JavaScript for the front end, and advance into back-end technologies like Node.js or databases. By combining theory with hands-on projects, learners leave with a portfolio-ready skill set and a solid grasp of modern development workflows, version control, and responsive design techniques that power today’s websites."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/cloud-computing",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: cloud,
                programLabel: "Cloud Computing",
                programText: "Master cloud infrastructure and services, and discover how to deploy, scale, and manage applications in a distributed environment.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1108",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in cloud-computing",
                note: "Explore the evolving world of cloud technology in this foundational course tailored for professionals looking to adapt to the future of computing. You’ll gain hands-on experience with cloud service models (IaaS, PaaS, SaaS), understand deployment frameworks, and explore cloud security, virtualization, and storage. This course empowers you with the know-how to migrate and manage systems in cloud platforms like AWS, Azure, or Google Cloud with confidence."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/artificial-intelligence",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: AI,
                programLabel: "Artificial Intelligence",
                programText: "Step into the realm of artificial intelligence and learn how to build systems that think, learn, and adapt.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "833",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in artificial-intelligence",
                note: "In this course, learners are introduced to the fascinating world of AI from machine learning algorithms to intelligent decision-making systems. You’ll explore supervised and unsupervised learning, neural networks, and real-life use cases such as recommendation engines and chatbots. This is more than just theory; each module comes with practical implementations using tools like Python and TensorFlow, preparing you for future roles in automation and intelligent system design."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/big-data",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: bigData,
                programLabel: "Big Data",
                programText: "Dive into the complexities of big data and learn how to collect, analyze, and visualize massive datasets effectively.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "269",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in big-data",
                note: "Designed for the data-driven professional, this course explores the tools and technologies needed to handle large-scale data. You’ll learn the principles of distributed systems like Hadoop and Spark, explore data ingestion pipelines, and gain exposure to structured and unstructured data handling. By the end of this course, you’ll be able to derive actionable insights from big data sets and support data-driven decision-making in any organization."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/data-science",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: dataScience,
                programLabel: "Data Science",
                programText: "Transform data into insights and drive intelligent decision-making through the power of data science.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "343",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in data-science",
                note: "This immersive course walks you through the entire data science pipeline, from data collection and cleaning to analysis and predictive modeling. Using Python and essential libraries like Pandas, NumPy, and Scikit-learn, you’ll build your understanding of statistical analysis, machine learning, and data visualization. Whether you’re entering the field or upskilling, this course gives you the edge to work with real data and build intelligent solutions that matter."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/social-media-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: SMM,
                programLabel: "Social Media Management",
                programText: "Develop the skills to strategize, manage, and grow powerful social media campaigns across major platforms.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "947",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in social-media-management",
                note: "This course delivers an actionable framework for mastering the tools and strategies needed in the fast-paced world of social media. You'll learn how to craft compelling content, manage brand identity, schedule posts with efficiency, and track engagement using industry-standard analytics tools. From organic growth to paid advertising, this course equips you to plan and execute high-converting campaigns on platforms like Facebook, Instagram, Twitter, LinkedIn, and TikTok. Ideal for aspiring digital marketers, brand managers, and entrepreneurs looking to amplify their digital presence."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/human-resource-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: HumanResourceManagement,
                programLabel: "Human Resource Management",
                programText: "Gain a thorough understanding of HR practices and learn how to lead, manage, and support a thriving workforce.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "122",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in human-resource-management",
                note: "This course is built for future HR leaders seeking to understand every facet of employee lifecycle management. You'll explore key HR functions such as recruitment, onboarding, performance evaluation, employee relations, compliance, and organizational culture. Through real-world scenarios and case studies, you’ll also gain insights into labor law, conflict resolution, compensation strategies, and leadership development. Whether you aim to join a corporate HR team or manage people within your business, this course provides essential tools for building and sustaining a productive workforce."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/project-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: projectManagement,
                programLabel: "Project Management",
                programText: "Learn how to initiate, plan, execute, and close successful projects on time and within budget.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1650",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in project-management",
                note: "This comprehensive course offers a deep dive into the principles and methodologies of modern project management. You’ll explore tools like Gantt charts, risk assessments, and stakeholder management strategies, while mastering frameworks such as Agile, Scrum, and Waterfall. Through simulations and guided exercises, you'll practice breaking down project requirements, building timelines, allocating resources, and managing teams. This course prepares you to lead projects of any size with confidence and clarity, making it ideal for managers, team leads, and coordinators across industries."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/customer-service",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: CS,
                programLabel: "Customer Service",
                programText: "Master the art of exceptional customer service and deliver positive experiences that build lasting brand loyalty.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "139",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in customer-service",
                note: "Designed for both front-line staff and team supervisors, this course focuses on delivering high-impact customer service in any business setting. You’ll learn the psychology of customer behavior, techniques for handling complaints, and methods to exceed expectations in both in-person and digital interactions. Using practical case studies, the course addresses tone, empathy, product knowledge, and crisis resolution strategies to turn frustrated clients into loyal advocates. Ideal for professionals who want to enhance their communication and customer handling skills."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/risk-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: risKManagement,
                programLabel: "Risk Management",
                programText: "Identify, assess, and mitigate risks with strategic planning tools that safeguard business goals.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1752",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in risk-management",
                note: "This course offers an analytical approach to recognizing, evaluating, and responding to a wide range of organizational risks. Whether it's financial, operational, compliance-based, or reputational, you’ll gain the skills needed to perform risk assessments and implement mitigation strategies. You'll also explore the use of risk matrices, audits, control systems, and compliance standards like ISO 31000. With real-life case studies and actionable frameworks, this course prepares professionals to make informed decisions that protect and sustain business value."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/marketing",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: marketing,
                programLabel: "Marketing",
                programText: "Learn how to attract, engage, and convert audiences using modern marketing principles and strategies.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1166",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in marketing",
                note: "Dive into the full spectrum of marketing fundamentals, from understanding consumer behavior to executing cross-channel campaigns. This course covers both digital and traditional marketing techniques, including branding, copywriting, SEO, email marketing, influencer campaigns, and performance analytics. You’ll also explore segmentation, targeting, and positioning to design strategies that drive real business growth. Perfect for marketers, entrepreneurs, or anyone looking to master the art of persuasion and brand visibility in a competitive marketplace."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/accounting",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: accounting,
                programLabel: "Accounting",
                programText: "Build a solid foundation in accounting principles, financial reporting, and business budgeting essentials.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1753",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in accounting",
                note: "This beginner-friendly course demystifies accounting concepts and introduces learners to the language of business finance. You'll understand how to read financial statements, track revenue and expenses, and calculate key performance indicators. Topics include double-entry bookkeeping, ledgers, trial balances, and profit/loss analysis. Practical exercises reinforce your knowledge of budgeting and tax considerations. Whether you’re preparing for a role in finance or simply want to manage your personal or business accounts more effectively, this course delivers core competencies that matter."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/sales-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: salesManagement,
                programLabel: "Sales Management",
                programText: "Discover how to lead high-performing sales teams and drive consistent revenue growth through strategy and motivation.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1470",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in sales-management",
                note: "This course teaches you how to build, motivate, and manage sales teams using proven methodologies. You’ll gain insight into pipeline forecasting, performance metrics, sales coaching, and negotiation strategies. You'll also explore CRM tools and digital sales platforms that streamline prospecting and follow-ups. Perfect for aspiring sales managers or entrepreneurs, this course helps you align sales objectives with business goals, manage team morale, and close deals effectively in fast-paced environments."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/information-technology",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: IT,
                programLabel: "Information Technology",
                programText: "Explore IT systems, networking, and security while building hands-on skills to support enterprise-level tech environments.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "774",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in information-technology",
                note: "This course is a complete guide to understanding the foundations of modern IT infrastructure. It covers networking basics, system administration, database management, cloud integration, and cybersecurity protocols. You’ll also learn how to troubleshoot hardware/software issues, configure devices, and maintain secure IT environments. This practical course is designed for tech enthusiasts, office managers, or anyone seeking a career path in IT support, systems analysis, or network management."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/supply-chain-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: SCM,
                programLabel: "Supply Chain Management",
                programText: "Develop in-demand skills in supply chain management, with a hands-on curriculum tailored for professional success.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "196",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in supply chain management",
                note: "This course provides a practical and strategic overview of supply chain operations, covering procurement, logistics, inventory control, demand planning, and supplier relationship management. You’ll explore global sourcing strategies, warehouse systems, distribution networks, and how data drives decision-making in modern supply chains. With hands-on simulations and industry case studies, learners develop the ability to enhance efficiency, reduce costs, and manage risks in complex supply networks skills that are vital in today's interconnected business world."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/product-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: projectManagement,
                programLabel: "Product Management",
                programText: "Lead the creation and growth of successful products by mastering the tools and mindset of a product manager.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1800",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in product-management",
                note: "This course immerses you in the lifecycle of product development, from idea generation and market research to launch and optimization. You’ll gain skills in stakeholder communication, roadmap planning, feature prioritization, and agile methodologies. Whether working with engineers, designers, or marketing teams, you’ll learn to align cross-functional efforts toward user-centered solutions. This program equips aspiring product managers with a strategic toolkit to lead innovation, measure impact, and build products that deliver lasting value in dynamic markets."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/product-design",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: pd,
                programLabel: "Product Design",
                programText: "Combine creativity and usability to design products that are intuitive, impactful, and user-focused.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "597",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in product-design",
                note: "This hands-on course explores the full spectrum of product design from user research and wireframing to visual aesthetics and interaction design. You'll dive into tools like Figma or Sketch, apply design thinking principles, and test your ideas through prototyping and user feedback. Emphasis is placed on creating accessible, functional, and beautiful interfaces that solve real problems. Ideal for aspiring designers, this course helps you build a portfolio while sharpening the critical thinking and creativity needed to thrive in tech and product-driven industries."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/design-thinking",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: dt,
                programLabel: "Design Thinking",
                programText: "Discover how to solve complex problems creatively through human-centered design approaches and innovation frameworks.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1966",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in design-thinking",
                note: "This immersive course guides learners through each stage of the design thinking process from empathizing with users to prototyping solutions and testing ideas. You’ll explore real-world case studies, ideation techniques, and collaborative problem-solving strategies that foster creativity, agility, and innovation. Whether you're in tech, education, or entrepreneurship, this course provides practical tools for designing impactful and user-driven solutions."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/brand-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: bm,
                programLabel: "Brand Management",
                programText: "Build and grow powerful brands through strategic storytelling, visual identity, and market positioning.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "761",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in brand-management",
                note: "This course explores the mechanics of building successful brands that resonate with audiences and stand out in competitive markets. You'll learn how to define brand voice, manage perception, create campaigns, and monitor brand equity. With examples from global companies and exercises in brand storytelling, positioning, and consistency, this course equips learners with the tools to manage brands that thrive and evolve over time."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/laravel-programming",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: laravel,
                programLabel: "Laravel Programming",
                programText: "Create robust, scalable, and secure web applications using Laravel’s powerful PHP framework.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "743",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in laravel-programming",
                note: "Learn how to build dynamic and secure web apps using Laravel, one of the most popular PHP frameworks. This course covers routing, middleware, Blade templating, database migrations, and RESTful API development. With real-world projects and a hands-on approach, you’ll gain the skills to architect modern applications efficiently while maintaining clean, testable code."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/java-programming",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: java,
                programLabel: "Java Programming",
                programText: "Master Java’s object-oriented principles and build powerful applications across desktop, web, and mobile platforms.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1364",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in java-programming",
                note: "This course offers an in-depth journey into Java programming, from variables and control structures to advanced topics like multithreading and file I/O. You’ll work on mini-projects that mimic enterprise-level development and learn how to debug, refactor, and optimize Java code. Whether you're building software, Android apps, or backend services, this course sets a strong foundation for long-term success."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/payroll-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: payroll,
                programLabel: "Payroll Management",
                programText: "Streamline payroll operations and ensure compliance with tax and labor regulations effectively.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1734",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in payroll-management",
                note: "Gain the knowledge and tools to manage payroll systems with accuracy and legal compliance. This course covers salary structure, statutory deductions, employee benefits, tax filing, and payroll software operations. It’s designed to help HR professionals and finance personnel reduce errors, improve reporting, and ensure employees are paid accurately and on time."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/customer-relationship-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: crm,
                programLabel: "Customer Relationship Management",
                programText: "Develop strategies to build long-term customer relationships and drive loyalty with CRM systems.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1597",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in customer-relationship-management",
                note: "This course explores the fundamentals of CRM and how to implement systems that improve customer engagement and retention. You’ll learn about CRM tools, customer segmentation, personalized outreach, and sales funnel optimization. Perfect for marketers, sales reps, and business owners looking to cultivate strong client relationships that drive recurring revenue."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/banking-and-finance",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: bf,
                programLabel: "Banking and Finance",
                programText: "Explore core principles of banking systems, financial instruments, and global economic operations.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1707",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in banking-and-finance",
                note: "Learn how financial institutions operate, how monetary policy impacts markets, and how investment instruments are used in personal and corporate finance. This course covers commercial banking, lending practices, capital markets, risk management, and financial planning. Ideal for finance professionals, analysts, and anyone entering the banking sector."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/compensation-and-benefits",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: cb,
                programLabel: "Compensation and Benefits",
                programText: "Design and manage fair, competitive, and motivating compensation structures for today’s workforce.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "222",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in compensation-and-benefits",
                note: "This course provides HR professionals with the knowledge to build sustainable salary structures, incentive programs, and employee benefits plans. Topics include internal equity, external competitiveness, job evaluation, and pay-for-performance models. You'll also learn how to navigate laws and compliance issues while keeping employee satisfaction and company goals in balance."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/performance-appraisal",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: pa,
                programLabel: "Performance Appraisal",
                programText: "Evaluate employee performance effectively with structured feedback systems and goal tracking.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1171",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in performance-appraisal",
                note: "This course teaches managers and HR specialists how to design and implement performance appraisal systems that drive accountability and growth. You'll explore KPI setting, 360-degree feedback, performance reviews, and strategies for coaching underperformers. By the end, you’ll be able to turn evaluations into actionable development plans."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/talent-acquisition",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: ta,
                programLabel: "Talent Acquisition",
                programText: "Recruit, assess, and onboard top talent using effective sourcing and selection strategies.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1548",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in talent-acquisition",
                note: "This course covers every stage of modern recruitment from writing compelling job descriptions and sourcing candidates to interviewing and onboarding. You'll explore tools like ATS systems, recruitment marketing, behavioral assessments, and metrics for measuring hiring effectiveness. It's perfect for HR professionals and hiring managers who want to attract and retain high-caliber talent."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/hr-analytics",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: hr,
                programLabel: "HR Analytics",
                programText: "Leverage data and analytics to drive strategic HR decisions and optimize workforce performance.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1992",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in hr-analytics",
                note: "This course empowers HR professionals to make data-driven decisions by teaching how to collect, interpret, and apply workforce metrics. You’ll learn predictive analytics, attrition modeling, employee engagement analysis, and performance trend tracking. With hands-on projects using real HR data, this course enhances your ability to influence organizational growth through measurable people insights."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/public-health",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: ph,
                programLabel: "Public Health",
                programText: "Understand the principles and challenges of promoting health and preventing disease in communities.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1392",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in public-health",
                note: "This course introduces key topics in global and local public health, including disease prevention, health education, epidemiology, and policy-making. You'll explore real-world health case studies, learn to assess population needs, and design impactful interventions. Whether you're pursuing a career in healthcare or nonprofit work, this program prepares you to make a difference at the community level."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/content-writing",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: content,
                programLabel: "Content Writing",
                programText: "Craft compelling and purposeful content for blogs, websites, social media, and marketing campaigns.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1689",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in content-writing",
                note: "This course equips aspiring writers with the skills to plan, structure, and write effective digital content. From storytelling to SEO best practices, you'll learn how to adapt tone for different platforms and engage your target audience. You'll also complete writing challenges and receive feedback to sharpen your technique, making you job-ready for freelance or corporate writing roles."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/pinterest-marketing",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: pinterest,
                programLabel: "Pinterest Marketing",
                programText: "Tap into Pinterest's visual power to build brand awareness and drive targeted traffic to your business.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1463",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in pinterest-marketing",
                note: "Learn how to create optimized Pins, boards, and strategies that turn Pinterest into a high-converting traffic engine. This course covers keyword research, audience targeting, content calendars, and using analytics to grow your reach. Whether you're promoting products or blog content, you'll leave equipped to create a Pinterest presence that delivers real results."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/audit-and-internal-control-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: aicm,
                programLabel: "Audit and Internal Control Management",
                programText: "Master auditing techniques and internal control frameworks to strengthen organizational integrity.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1338",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in audit-and-internal-control-management",
                note: "This course provides an in-depth look at auditing procedures, risk management, compliance, and control systems. You’ll learn to design audit programs, detect irregularities, and evaluate internal policies for efficiency and transparency. Ideal for accounting professionals and compliance officers, this course builds critical skills for maintaining accountability and preventing fraud."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/fintech-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Fintech,
                programLabel: "Fintech Management",
                programText: "Navigate the evolving world of digital finance, blockchain, and financial innovation with confidence.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "796",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in fintech-management",
                note: "Dive into the fast-growing fintech sector and learn how emerging technologies are reshaping payments, lending, investment, and banking. You’ll explore blockchain, digital wallets, robo-advisors, and regulatory technology, with case studies from top fintech firms. This course equips you to lead or collaborate in tech-driven finance environments where innovation meets regulation."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/communications-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: ccm,
                programLabel: "Communications Management",
                programText: "Build and deliver effective internal and external communications in professional environments.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1557",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in communications-management",
                note: "This course covers the principles of corporate communication, stakeholder engagement, and strategic messaging. You’ll learn how to manage PR crises, lead communications in project teams, write clear business documents, and use digital platforms for outreach. It's ideal for professionals aiming to influence, inform, and connect through purposeful communication."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/operations-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: om,
                programLabel: "Operations Management",
                programText: "Streamline business operations by improving processes, productivity, and resource utilization.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "742",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in operations-management",
                note: "This course teaches the fundamentals of operations from process analysis and workflow optimization to inventory control and supply chain alignment. You’ll apply techniques like Lean, Six Sigma, and continuous improvement to real-world business scenarios. It’s suited for professionals looking to boost efficiency, reduce waste, and enhance overall operational performance."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/business-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: businessManagement,
                programLabel: "Business Management",
                programText: "Lead teams, manage resources, and make strategic decisions to drive business success.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1172",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in business-management",
                note: "This course provides a broad foundation in management principles including leadership, finance, operations, and organizational behavior. You’ll explore how to set goals, manage conflict, assess performance, and adapt to change in dynamic environments. Perfect for aspiring managers or entrepreneurs seeking a solid grasp of business fundamentals."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/property-and-asset-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: pam,
                programLabel: "Property and Asset Management",
                programText: "Manage real estate portfolios and physical assets for long-term growth and operational efficiency.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "777",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in property-and-asset-management",
                note: "This course dives into property lifecycle management, including acquisition, maintenance, valuation, leasing, and divestment. You'll learn to develop asset strategies, evaluate property risks, and oversee tenant relations. With insights from both real estate and facilities management, this course prepares professionals to enhance value while minimizing operational costs."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/monitoring-and-evaluation",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: me,
                programLabel: "Monitoring and Evaluation",
                programText: "Develop strong analytical skills to track project progress, assess impact, and optimize performance.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1646",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in monitoring-and-evaluation",
                note: "This course offers practical insights into designing monitoring systems and evaluation frameworks that help organizations make informed, evidence-based decisions. You'll gain expertise in data collection tools, performance indicators, and result-based reporting, preparing you for roles in NGOs, government, or corporate project oversight."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/digital-marketing",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: dm,
                programLabel: "Digital Marketing",
                programText: "Create and manage effective digital campaigns using SEO, social media, PPC, and content strategy.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "213",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in digital-marketing",
                note: "This course equips you with a full digital marketing toolkit SEO, Google Ads, content marketing, and more tailored for real-world business goals. Learn how to build customer funnels, boost conversions, and analyze performance using modern tools and data. Ideal for business owners, marketers, and freelancers."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/copywriting",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Copywriting,
                programLabel: "Copywriting",
                programText: "Write persuasive, engaging copy that converts audiences into loyal customers.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "519",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in copywriting",
                note: "Master the psychology of words and how to craft attention-grabbing headlines, email campaigns, landing pages, and ads. You'll explore storytelling, emotional triggers, and brand voice development while building a portfolio of compelling work. Perfect for marketers, entrepreneurs, and content creators."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/procurement",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Procurement,
                programLabel: "Procurement",
                programText: "Gain the expertise to source suppliers, negotiate contracts, and manage purchasing processes efficiently.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "343",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in procurement",
                note: "This course dives into supplier selection, cost management, contract law, and purchasing ethics. Learn how to optimize procurement cycles, implement e-procurement tools, and align sourcing with business goals. Ideal for supply chain professionals and aspiring procurement managers."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/office-administration",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: oa,
                programLabel: "Office Administration",
                programText: "Run efficient office operations and support organizational success with administrative expertise.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "715",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in office-administration",
                note: "This course equips learners with skills in office organization, records management, scheduling, and basic HR and finance tasks. You’ll master digital tools, communication techniques, and workflow optimization, making you a key support pillar in any workplace setting."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/hospitality-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Hospitality,
                programLabel: "Hospitality Management",
                programText: "Master service excellence, guest relations, and operational leadership in the hospitality industry.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1191",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in hospitality-management",
                note: "From front desk operations to event planning, this course teaches the foundations of hotel, resort, and restaurant management. Learn about customer service, quality assurance, budgeting, and staff coordination to build a thriving hospitality environment."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/hse-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: HSE,
                programLabel: "HSE Management",
                programText: "Promote workplace safety and environmental compliance through strategic HSE leadership.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1732",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in hse-management",
                note: "This course covers risk assessment, occupational health regulations, safety planning, and environmental controls. You’ll gain practical tools for accident prevention, incident response, and audits essential for HSE officers, facility managers, and engineers in high-risk industries."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/financial-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: fm,
                programLabel: "Financial Management",
                programText: "Analyze financial data, plan budgets, and guide businesses toward smart fiscal decisions.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1995",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in financial-management",
                note: "You’ll learn how to interpret financial statements, manage cash flows, evaluate investments, and create strategic budgets. This course helps business leaders and finance professionals control risk, drive profitability, and align spending with long-term goals."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/warehouse-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Warehouse,
                programLabel: "Warehouse Management",
                programText: "Streamline inventory, optimize space, and coordinate warehouse operations for peak efficiency.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1992",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in warehouse-management",
                note: "Gain hands-on knowledge of receiving, storage systems, picking, packing, and order fulfillment. Learn best practices in layout planning, stock control, and warehouse software to minimize errors and maximize productivity in modern logistics."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/logistics-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Logistics,
                programLabel: "Logistics Management",
                programText: "Coordinate supply chain activities, transportation, and delivery systems with precision.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1769",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in logistics-management",
                note: "This course explores shipping methods, third-party logistics, tracking systems, and demand forecasting. You’ll develop operational strategies that reduce delays and improve delivery reliability essential for logistics coordinators and managers."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/materials-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Materials,
                programLabel: "Materials Management",
                programText: "Develop a strong command of materials flow, procurement, and resource allocation to streamline business operations.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1946",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in materials-management",
                note: "This course trains professionals to manage materials and supplies effectively within any organization. It covers key areas such as stock level control, procurement planning, logistics coordination, and waste reduction   all aimed at improving operational efficiency and reducing overhead costs."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/inventory-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: Inventory,
                programLabel: "Inventory Management",
                programText: "Gain hands-on skills to track, optimize, and manage inventory systems across diverse industries.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "708",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in inventory-management",
                note: "This course explores inventory strategies such as FIFO/LIFO methods, automated systems, auditing techniques, and demand forecasting. Learners will understand how to avoid stockouts, minimize excess inventory, and build systems that align with real-time supply chain goals."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/wordpress-operations-pro",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: wordpress,
                programLabel: "WordPress Operations Pro",
                programText: "Build powerful, responsive websites using WordPress with a focus on backend operations, content workflows, and plugin architecture.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "235",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in wordpress-operations-pro",
                note: "This course is tailored to help learners master both the visible and behind-the-scenes operations of WordPress. From installing and configuring plugins to automating publishing processes and optimizing for performance, participants will gain practical skills that empower them to create and manage high-functioning websites for business or freelance purposes."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/product-analytics",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: productAnalysis,
                programLabel: "Product Analytics",
                programText: "Unlock the power of product data by learning analytics techniques that drive smarter product decisions and user growth.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1837",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in product-analytics",
                note: "Dive into a curriculum designed to teach you how to measure product performance using key metrics, interpret behavioral trends, and generate insights that influence product roadmaps. This course empowers learners to make data-backed decisions, identify churn points, and optimize the user experience in real-world business contexts."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/instagram-marketing-and-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: instagram,
                programLabel: "Instagram Marketing & Management",
                programText: "Master the art of growing and managing Instagram accounts for brands, influencers, and campaigns with strategic insight.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1395",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in instagram-marketing-&-management",
                note: "This course walks you through Instagram content strategy, analytics, ad management, and influencer collaborations. Learners will explore real case studies, learn algorithm hacks, and practice storytelling methods that convert followers into loyal customers   all within the Instagram ecosystem."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/facebook-ads-and-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: facebook,
                programLabel: "Facebook Ads and Management",
                programText: "Become proficient in Facebook advertising and page management to run data-driven campaigns that maximize ROI.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "456",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in facebook-ads-and-management",
                note: "This hands-on course covers the full spectrum of Facebook Ads from creating ad creatives and setting up pixel tracking to targeting audiences and analyzing ad reports. Learners will gain the tools and templates to manage ad accounts, scale campaigns efficiently, and drive measurable growth for businesses or clients."
            },
            {
                addToCart: false,
                projectPath: "/executive-diploma/twitter-operations-and-management",
                programName: "EXECUTIVE DIPLOMA",
                programNamesOnCart: "Executive Diploma",
                programImg: twitter,
                programLabel: "Twitter Operations and Management",
                programText: "Learn to manage Twitter accounts with an edge through content planning, trends leverage, and engagement analytics.",
                programPrice: "10",
                programPriceInNG: '15,000',
                reviews: "1253",
                duration: "1 Month",
                mode: "Online & Self-Paced",
                certificate: "Executive Diploma Certificate in twitter-operations-and-management",
                note: "This course equips learners with the tactical know-how to run high-performing Twitter profiles. From creating viral threads and Twitter Spaces to handling brand crisis communication, you’ll master how to grow an audience and maintain a professional, responsive Twitter presence tailored for success in digital communications."
            }
        ]
    },
]

export default ProgramDetails